import { Accessor, createSignal, Setter, Show } from "solid-js";
import { A } from "@solidjs/router";
import { zIndexes } from "~/z_indexes";
import { Mode } from "~/types";
import { PhosphorIcon } from "~/widgets/icons";
import { HeaderMenu } from "./header_menu";

const indriyaLogoUrl =
  "https://assets.myhubble.money/web-assets/corp-gifting/indriya_rectangle_logo.webp";
const iciciLogoUrl =
  "https://assets.myhubble.money/web-assets/corp-gifting/icici_bank_logo_rectangle.jpg";

type IciciIndriyaHeaderProps = {
  isLoggedIn: boolean;
  mode: Mode;
  clientId: string;
  isDropdownOpen: Accessor<boolean>;
  setIsDropdownOpen: Setter<boolean>;
};

export const IciciIndriyaHeader = (props: IciciIndriyaHeaderProps) => {
  const [menuButtonRef, setMenuButtonRef] = createSignal<HTMLDivElement>();

  return (
    <div
      class="sticky top-0 h-[64px] w-full border-b border-baseTertiaryDark bg-baseTertiaryLight sm:h-[68px]"
      style={{ "z-index": zIndexes.header }}
    >
      <div class="mx-auto flex h-full w-full max-w-[1200px] flex-row items-center justify-between px-4 sm:px-6">
        <A href="/" class="flex items-center">
          <img
            id="indriya-header-logo"
            src={indriyaLogoUrl}
            alt="Indriya logo"
            class="h-9 w-auto sm:h-12"
          />
        </A>

        <div class="flex flex-row items-center gap-2 sm:gap-4">
          <img
            id="icici-header-logo"
            src={iciciLogoUrl}
            alt="ICICI Bank logo"
            class="h-8 w-auto sm:h-8"
          />

          <Show when={props.isLoggedIn}>
            {/* [&_#header-menu]:!hidden hides HeaderMenu's built-in desktop trigger — we use our own hamburger on all breakpoints. */}
            <div class="relative [&_#header-menu]:!hidden">
              <div
                ref={setMenuButtonRef}
                class="cursor-pointer p-1 text-textNormal"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  props.setIsDropdownOpen(!props.isDropdownOpen());
                }}
              >
                <Show
                  when={props.isDropdownOpen()}
                  fallback={
                    <PhosphorIcon name="list" fontSize={28} size={"bold"} />
                  }
                >
                  <PhosphorIcon name="x" fontSize={28} size={"bold"} />
                </Show>
              </div>
              <div onClick={(e) => e.stopPropagation()}>
                <HeaderMenu
                  isLoggedIn={props.isLoggedIn}
                  mode={props.mode}
                  isDropdownOpen={props.isDropdownOpen}
                  setIsDropdownOpen={props.setIsDropdownOpen}
                  clientId={() => props.clientId}
                  showMyGiftCards={() => false}
                  fAQsInHeader={[]}
                  headerButtonRef={menuButtonRef}
                />
              </div>
            </div>
          </Show>
        </div>
      </div>
    </div>
  );
};
